import styled from "styled-components";

export const Input = styled.input`
  height: 2.5rem;
  width: 20rem;
  border-radius: 10px;
  border: none;
  font-size: 25px;
  padding-left: 3rem;
  padding-right: 3rem;
  margin-bottom: 3rem;
  margin-top: 3rem;
`